"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContractService = void 0;
var contract_1 = require("./firmachain/contract");
var FirmaUtil_1 = require("./FirmaUtil");
var ContractService = /** @class */ (function () {
    function ContractService(config) {
        this.config = config;
    }
    ContractService.prototype.getContractLogAll = function (paginationKey) {
        if (paginationKey === void 0) { paginationKey = ""; }
        return __awaiter(this, void 0, void 0, function () {
            var contractQueryClient, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        contractQueryClient = new contract_1.ContractQueryClient(this.config.restApiAddress);
                        return [4 /*yield*/, contractQueryClient.queryContractLogAll(paginationKey)];
                    case 1: return [2 /*return*/, _a.sent()];
                    case 2:
                        error_1 = _a.sent();
                        FirmaUtil_1.FirmaUtil.printLog(error_1);
                        throw error_1;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    ContractService.prototype.getContractFileAll = function (paginationKey) {
        if (paginationKey === void 0) { paginationKey = ""; }
        return __awaiter(this, void 0, void 0, function () {
            var contractQueryClient, error_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        contractQueryClient = new contract_1.ContractQueryClient(this.config.restApiAddress);
                        return [4 /*yield*/, contractQueryClient.queryContractFileAll(paginationKey)];
                    case 1: return [2 /*return*/, _a.sent()];
                    case 2:
                        error_2 = _a.sent();
                        FirmaUtil_1.FirmaUtil.printLog(error_2);
                        throw error_2;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    ContractService.prototype.getContractFile = function (fileHash) {
        return __awaiter(this, void 0, void 0, function () {
            var contractQueryClient, error_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        contractQueryClient = new contract_1.ContractQueryClient(this.config.restApiAddress);
                        return [4 /*yield*/, contractQueryClient.queryContractFile(fileHash)];
                    case 1: return [2 /*return*/, _a.sent()];
                    case 2:
                        error_3 = _a.sent();
                        FirmaUtil_1.FirmaUtil.printLog(error_3);
                        throw error_3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    ContractService.prototype.getContractListFromHash = function (contractHash) {
        return __awaiter(this, void 0, void 0, function () {
            var contractQueryClient, error_4;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        contractQueryClient = new contract_1.ContractQueryClient(this.config.restApiAddress);
                        return [4 /*yield*/, contractQueryClient.queryGetContractListFromHash(contractHash)];
                    case 1: return [2 /*return*/, _a.sent()];
                    case 2:
                        error_4 = _a.sent();
                        FirmaUtil_1.FirmaUtil.printLog(error_4);
                        throw error_4;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    ContractService.prototype.isContractOwner = function (fileHash, ownerAddress) {
        return __awaiter(this, void 0, void 0, function () {
            var contractQueryClient, error_5;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        contractQueryClient = new contract_1.ContractQueryClient(this.config.restApiAddress);
                        return [4 /*yield*/, contractQueryClient.queryIsContractOwner(fileHash, ownerAddress)];
                    case 1: return [2 /*return*/, _a.sent()];
                    case 2:
                        error_5 = _a.sent();
                        FirmaUtil_1.FirmaUtil.printLog(error_5);
                        throw error_5;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    ContractService.prototype.getContractLog = function (logId) {
        return __awaiter(this, void 0, void 0, function () {
            var contractQueryClient, error_6;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        contractQueryClient = new contract_1.ContractQueryClient(this.config.restApiAddress);
                        return [4 /*yield*/, contractQueryClient.queryContractLog(logId)];
                    case 1: return [2 /*return*/, _a.sent()];
                    case 2:
                        error_6 = _a.sent();
                        FirmaUtil_1.FirmaUtil.printLog(error_6);
                        throw error_6;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    ContractService.prototype.getGasEstimationFromUnSignedTxList = function (wallet, txList, txMisc) {
        if (txMisc === void 0) { txMisc = FirmaUtil_1.DefaultTxMisc; }
        return __awaiter(this, void 0, void 0, function () {
            var contractTxClient, txRaw, error_7;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        contractTxClient = new contract_1.ContractTxClient(wallet, this.config.rpcAddress);
                        return [4 /*yield*/, contractTxClient.sign(txList, FirmaUtil_1.getSignAndBroadcastOption(this.config.denom, txMisc))];
                    case 1:
                        txRaw = _a.sent();
                        return [4 /*yield*/, FirmaUtil_1.FirmaUtil.estimateGas(txRaw)];
                    case 2: return [2 /*return*/, _a.sent()];
                    case 3:
                        error_7 = _a.sent();
                        FirmaUtil_1.FirmaUtil.printLog(error_7);
                        throw error_7;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    ContractService.prototype.getGasEstimationCreateContractFile = function (wallet, fileHash, timeStamp, ownerList, metaDataJsonString, txMisc) {
        if (txMisc === void 0) { txMisc = FirmaUtil_1.DefaultTxMisc; }
        return __awaiter(this, void 0, void 0, function () {
            var txRaw, error_8;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        return [4 /*yield*/, this.getSignedTxCreateContractFile(wallet, fileHash, timeStamp, ownerList, metaDataJsonString, txMisc)];
                    case 1:
                        txRaw = _a.sent();
                        return [4 /*yield*/, FirmaUtil_1.FirmaUtil.estimateGas(txRaw)];
                    case 2: return [2 /*return*/, _a.sent()];
                    case 3:
                        error_8 = _a.sent();
                        FirmaUtil_1.FirmaUtil.printLog(error_8);
                        throw error_8;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    ContractService.prototype.getUnsignedTxCreateContractFile = function (wallet, fileHash, timeStamp, ownerList, metaDataJsonString) {
        return __awaiter(this, void 0, void 0, function () {
            var address, error_9;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, wallet.getAddress()];
                    case 1:
                        address = _a.sent();
                        return [2 /*return*/, contract_1.ContractTxClient.msgCreateContractFile({
                                creator: address,
                                fileHash: fileHash,
                                timeStamp: timeStamp,
                                ownerList: ownerList,
                                metaDataJsonString: metaDataJsonString
                            })];
                    case 2:
                        error_9 = _a.sent();
                        FirmaUtil_1.FirmaUtil.printLog(error_9);
                        throw error_9;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    ContractService.prototype.getSignedTxCreateContractFile = function (wallet, fileHash, timeStamp, ownerList, metaDataJsonString, txMisc) {
        if (txMisc === void 0) { txMisc = FirmaUtil_1.DefaultTxMisc; }
        return __awaiter(this, void 0, void 0, function () {
            var address, message, contractTxClient, error_10;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        return [4 /*yield*/, wallet.getAddress()];
                    case 1:
                        address = _a.sent();
                        message = contract_1.ContractTxClient.msgCreateContractFile({
                            creator: address,
                            fileHash: fileHash,
                            timeStamp: timeStamp,
                            ownerList: ownerList,
                            metaDataJsonString: metaDataJsonString
                        });
                        contractTxClient = new contract_1.ContractTxClient(wallet, this.config.rpcAddress);
                        return [4 /*yield*/, contractTxClient.sign([message], FirmaUtil_1.getSignAndBroadcastOption(this.config.denom, txMisc))];
                    case 2: return [2 /*return*/, _a.sent()];
                    case 3:
                        error_10 = _a.sent();
                        FirmaUtil_1.FirmaUtil.printLog(error_10);
                        throw error_10;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    ContractService.prototype.createContractFile = function (wallet, fileHash, timeStamp, ownerList, metaDataJsonString, txMisc) {
        if (txMisc === void 0) { txMisc = FirmaUtil_1.DefaultTxMisc; }
        return __awaiter(this, void 0, void 0, function () {
            var txRaw, contractTxClient, error_11;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        return [4 /*yield*/, this.getSignedTxCreateContractFile(wallet, fileHash, timeStamp, ownerList, metaDataJsonString, txMisc)];
                    case 1:
                        txRaw = _a.sent();
                        contractTxClient = new contract_1.ContractTxClient(wallet, this.config.rpcAddress);
                        return [4 /*yield*/, contractTxClient.broadcast(txRaw)];
                    case 2: return [2 /*return*/, _a.sent()];
                    case 3:
                        error_11 = _a.sent();
                        FirmaUtil_1.FirmaUtil.printLog(error_11);
                        throw error_11;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    ContractService.prototype.getGasEstimationAddContractLog = function (wallet, contractHash, timeStamp, eventName, ownerAddress, jsonString, txMisc) {
        if (txMisc === void 0) { txMisc = FirmaUtil_1.DefaultTxMisc; }
        return __awaiter(this, void 0, void 0, function () {
            var txRaw, error_12;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        return [4 /*yield*/, this.getSignedTxAddContractLog(wallet, contractHash, timeStamp, eventName, ownerAddress, jsonString, txMisc)];
                    case 1:
                        txRaw = _a.sent();
                        return [4 /*yield*/, FirmaUtil_1.FirmaUtil.estimateGas(txRaw)];
                    case 2: return [2 /*return*/, _a.sent()];
                    case 3:
                        error_12 = _a.sent();
                        FirmaUtil_1.FirmaUtil.printLog(error_12);
                        throw error_12;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    ContractService.prototype.getSignedTxAddContractLog = function (wallet, contractHash, timeStamp, eventName, ownerAddress, jsonString, txMisc) {
        if (txMisc === void 0) { txMisc = FirmaUtil_1.DefaultTxMisc; }
        return __awaiter(this, void 0, void 0, function () {
            var address, message, contractTxClient, error_13;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        return [4 /*yield*/, wallet.getAddress()];
                    case 1:
                        address = _a.sent();
                        message = contract_1.ContractTxClient.msgAddContractLog({
                            creator: address,
                            contractHash: contractHash,
                            timeStamp: timeStamp,
                            eventName: eventName,
                            ownerAddress: ownerAddress,
                            jsonString: jsonString
                        });
                        contractTxClient = new contract_1.ContractTxClient(wallet, this.config.rpcAddress);
                        return [4 /*yield*/, contractTxClient.sign([message], FirmaUtil_1.getSignAndBroadcastOption(this.config.denom, txMisc))];
                    case 2: return [2 /*return*/, _a.sent()];
                    case 3:
                        error_13 = _a.sent();
                        FirmaUtil_1.FirmaUtil.printLog(error_13);
                        throw error_13;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    ContractService.prototype.addContractLog = function (wallet, contractHash, timeStamp, eventName, ownerAddress, jsonString, txMisc) {
        if (txMisc === void 0) { txMisc = FirmaUtil_1.DefaultTxMisc; }
        return __awaiter(this, void 0, void 0, function () {
            var txRaw, contractTxClient, error_14;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        return [4 /*yield*/, this.getSignedTxAddContractLog(wallet, contractHash, timeStamp, eventName, ownerAddress, jsonString, txMisc)];
                    case 1:
                        txRaw = _a.sent();
                        contractTxClient = new contract_1.ContractTxClient(wallet, this.config.rpcAddress);
                        return [4 /*yield*/, contractTxClient.broadcast(txRaw)];
                    case 2: return [2 /*return*/, _a.sent()];
                    case 3:
                        error_14 = _a.sent();
                        FirmaUtil_1.FirmaUtil.printLog(error_14);
                        throw error_14;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    ContractService.prototype.getUnsignedTxAddContractLog = function (wallet, contractHash, timeStamp, eventName, ownerAddress, jsonString) {
        return __awaiter(this, void 0, void 0, function () {
            var address, error_15;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, wallet.getAddress()];
                    case 1:
                        address = _a.sent();
                        return [2 /*return*/, contract_1.ContractTxClient.msgAddContractLog({
                                creator: address,
                                contractHash: contractHash,
                                timeStamp: timeStamp,
                                eventName: eventName,
                                ownerAddress: ownerAddress,
                                jsonString: jsonString
                            })];
                    case 2:
                        error_15 = _a.sent();
                        FirmaUtil_1.FirmaUtil.printLog(error_15);
                        throw error_15;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    ContractService.prototype.getGasEstimationSignAndBroadcast = function (wallet, msgList, txMisc) {
        if (txMisc === void 0) { txMisc = FirmaUtil_1.DefaultTxMisc; }
        return __awaiter(this, void 0, void 0, function () {
            var contractTxClient, txRaw, error_16;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        contractTxClient = new contract_1.ContractTxClient(wallet, this.config.rpcAddress);
                        return [4 /*yield*/, contractTxClient.sign(msgList, FirmaUtil_1.getSignAndBroadcastOption(this.config.denom, txMisc))];
                    case 1:
                        txRaw = _a.sent();
                        return [4 /*yield*/, FirmaUtil_1.FirmaUtil.estimateGas(txRaw)];
                    case 2: return [2 /*return*/, _a.sent()];
                    case 3:
                        error_16 = _a.sent();
                        FirmaUtil_1.FirmaUtil.printLog(error_16);
                        throw error_16;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    ContractService.prototype.signAndBroadcast = function (wallet, msgList, txMisc) {
        if (txMisc === void 0) { txMisc = FirmaUtil_1.DefaultTxMisc; }
        return __awaiter(this, void 0, void 0, function () {
            var contractTxClient, error_17;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        contractTxClient = new contract_1.ContractTxClient(wallet, this.config.rpcAddress);
                        return [4 /*yield*/, contractTxClient.signAndBroadcast(msgList, FirmaUtil_1.getSignAndBroadcastOption(this.config.denom, txMisc))];
                    case 1: return [2 /*return*/, _a.sent()];
                    case 2:
                        error_17 = _a.sent();
                        FirmaUtil_1.FirmaUtil.printLog(error_17);
                        throw error_17;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    return ContractService;
}());
exports.ContractService = ContractService;
